import LocalStorage from "./LocalStorage";
import SessionStorage from "./SessionStorage";
import jwt_decode from "jwt-decode";
import dayjs from "dayjs";
import { environment } from "@environments/environment";

export default class HwUtils {
  public static leftPad(num: number, size: number): string {
    let s = num + "";
    while (s.length < size) s = "0" + s;
    return s;
  }
  public static GenerateDailyPassword(): string {
    const today = new Date();
    const day = today.getDate();
    const month = today.getMonth() + 1;  // JS months are 0-indexed
    let dt = (day + month).toString();
    dt = dt.length === 1 ? '0' + dt : dt;
    const kozepe =
      'stdeuno'[today.getDay()] +
      dt.charAt(1) +
      dt.charAt(0);
    return 'ab' + kozepe + '6'
  }
  public static getSubscriber() {
    if (LocalStorage.IsTabletMode) {
      const tabletToken = jwt_decode(LocalStorage.TabletToken)
      if (LocalStorage.OperationMode == "VIP") {
        return SessionStorage.ReservationInfo?.Subscriber
      } else {
        return tabletToken["SubscriberCode"].toString()
      }
    } else {
      return SessionStorage.ReservationInfo?.Subscriber
    }
  }

  public static getHotelId(): number {
    if (LocalStorage.IsTabletMode) {
      const tabletToken = jwt_decode(LocalStorage.TabletToken)
      if (LocalStorage.OperationMode == "VIP") {
        return parseInt(SessionStorage.ReservationInfo?.Hotelid)
      } else {
        return parseInt(tabletToken["SubscriberHtlNum"].toString())
      }
    } else {
      return parseInt(SessionStorage.ReservationInfo?.Hotelid)
    }
  }

  public static toTitleCase(inputString: string): string {

    return inputString
      .toLowerCase()                          // 1. Convert the entire string to lowercase
      .trim()                                 // 2. Remove leading/trailing whitespace
      .split(/\s+/)                           // 3. Split by one or more space characters
      .map(word => {
        return word.charAt(0).toUpperCase() + word.slice(1); // 4. Capitalize first letter
      })
      .join(' ');
  }
  public static log(message: string) {
    if (environment.logging) {
      const unixTime = Date.now() / 1000;
      const time = dayjs(unixTime).format("HH:mm:ss:SSS") // Convert seconds to milliseconds
      console.log(time + " - " + message)
    }
  }
}